module.exports = __webpack_public_path__ + "static/img/heyer.35e42dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heyer.png
// module id = KHOi
// module chunks = 1